import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { BigBlueIntegrationResponseDataSchema, DataResponse } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof BigBlueIntegrationResponseDataSchema>>

const queryKey = ["bigblueIntegration"]

export const bigblueIntegrationQuery = () => {
  return queryOptions({
    queryKey,
    queryFn: async () => {
      const response = await axios.get<Response>(`/integrations/bigblue/configuration`)

      return response.data.data
    },
  })
}
